__turbopack_context__.v({
  "className": "poppins_7772d14d-module__r_dJxa__className",
  "variable": "poppins_7772d14d-module__r_dJxa__variable",
});
